import { ws, gestioneSnackbar } from "../../utils/common";
import { isValidPassword, isValidEmail } from "../../utils/validation";

export const loginWS = async ({ email, password }) => {
  if (!isValidPassword(password)) {
    gestioneSnackbar(
      true,
      "La password non soddisfa i criteri standard",
      "error"
    );
    return false;
  }

  if (!isValidEmail(email)) {
    gestioneSnackbar(true, "Email non valida", "error");
    return false;
  }

  const res = await ws(
    "POST",
    process.env.REACT_APP_ENDPOINT + "auth/login/",
    null,
    {
      email,
      password,
    },
    false
  );

  if (res.error) {
    gestioneSnackbar(true, res.data.message, "error");
    throw res.data.message;
  } else {
    localStorage.setItem("accessToken", res.data.accessToken);
    window.location.replace("/");
  }
};
